import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { arePageFlagsPending, EventSettingsContextType, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';
import EventDetails from "../../shared/EventDetails";
import BookAMeetingPageInfo from "./BookAMeetingPageInfo";
import { BookAMeetingPageType } from '../../../lib/api/custom-page.types';
import isEnabledRoute from '../../../hooks/use-enabled-route';
import { IAuthContext, useAuth } from '../../../lib/context-providers/auth-context';
import { useMeetingSlots } from '../../../hooks/api/protected/use-meeting-slots';
import { CustomSettingsContextType, useSettings } from '../../../lib/context-providers/custom-settings-context';

const BookAMeetingPageWrapper: React.FC<BookAMeetingPageType> = (props: BookAMeetingPageType): JSX.Element | null => {
  const auth = useAuth() as IAuthContext;
  const { data } = useMeetingSlots(props.customPageId);
  const eventSettings = useEventSettings() as EventSettingsContextType;
  const customSettings = useSettings() as CustomSettingsContextType;
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null);
  const hasMultipleGroups = data?.groups && data.groups.length > 1;
  const selectedGroup = hasMultipleGroups && selectedGroupId
    ? data?.groups?.find(g => g.id === selectedGroupId) || data?.groups?.[0]
    : null;
  const groupData = selectedGroup || {
    id: data?.id ?? '',
    label: data?.label ?? '',
    speakers: data?.speakers || [],
    meetingSlots: data?.meetingSlots || [],
    eventTimeZone: data?.eventTimeZone,
  };
  const presenterGroups = (data?.groups ?? [])
    .filter(item => item.id && item.label)
    .map(item => ({ id: item.id, label: item.label }));

  const enabledRoute = isEnabledRoute(eventSettings?.landingPage);

  if (arePageFlagsPending(eventSettings)) return null;

  if ((auth.isAuthenticated && !props?.enabled) || (auth.isAuthenticated === false && !props?.publicEnabled)) {
    return <Redirect to={enabledRoute} />;
  }

  if (eventSettings && data) {
    return (
      <>
        <EventDetails details={eventSettings} />
        <BookAMeetingPageInfo
          label={props?.label}
          groupData={groupData}
          eventSettings={eventSettings}
          presenterGroups={presenterGroups}
          selectedGroupId={selectedGroupId}
          onTabChange={(tabId) => setSelectedGroupId(tabId)}
          isSinglePresenterGroup={Boolean(data?.groups?.length === 1)}
          primaryColor={customSettings?.primaryColorHash || null}
        />
      </>
    );
  }
  return null;
};

export { BookAMeetingPageWrapper };
